export enum EmployeeRole {
  BUSINESS_ADMIN = 'ROLE_BUSINESS_ADMIN',
  MANAGER = 'ROLE_MANAGER',
  DISPATCHER = 'ROLE_DISPATCHER',
  PLANNER = 'ROLE_PLANNER',
  FORWARDER = 'ROLE_FORWARDER',
  HR_AND_PAYROLL = 'ROLE_HR_AND_PAYROLL',
  TRADER = 'ROLE_TRADER',
}
